import { useState } from 'react';
import Input from '../Atoms/Input';
import { useTranslation } from 'react-i18next';
import * as api from '../../api';
import React from 'react';
import styled from 'styled-components';
import Spinner from '../../Plateforme/Atoms/Spinner';

const Container = styled.div`
    position: relative;
    width: 100%;

    > span {
        display: inline-block;
        width: 100%;
        padding: 10px 0;
        border-bottom: 1px solid #ccc;
        span {
            cursor: pointer;
            > img {
                display: inline-block;
                margin: 0;
                margin-left: 10px;
                width: 12px;
            }
        }
    }

    .hidden {
        display: none;
    }
    
    .select_panel {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        background-color: white;
        border-top: none;
        border: 0.5px solid black;
        z-index: 2;

        .select_option {
            padding: 10px 20px;
            border: 0.5px solid black;
            cursor: pointer;

            &:hover {
                background-color: #f4f4f4;
            }
        }

        .info {
            padding: 10px 20px;
            border: 0.5px solid black;
            font-size: 14px;
        }
    }
`;

const CompanySelect = (props) => {

    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(props.selectedCompany || {});

    const [searchInput, setSearchInput] = useState('');
    const [lastSearchedInput, setLastSearchedInput] = useState('');
    const [isSearching, setIsSearching] = useState(false);
    const [inputFocused, setInputFocused] = useState(false);

    const { i18n } = useTranslation('common');

    // Update selectedCompany when props.selectedCompany changes
    React.useEffect(() => {
        if (props.selectedCompany && props.selectedCompany.id) {
            setSelectedCompany(props.selectedCompany);
        }
    }, [props.selectedCompany]);

    React.useEffect(() => {
        if(lastSearchedInput === searchInput) return;
        if(isSearching) return;
        // console.log("searching for : " + searchInput);
        setLastSearchedInput(searchInput);
        setIsSearching(true);
        api.SearchCompany({search : searchInput}).then((response) => {
            // console.log(response.data);
            setIsSearching(false);
            setCompanyList(response.data);
        }).catch((error) => {
            console.log(error);
            setIsSearching(false);
        });
    }, [searchInput,isSearching,lastSearchedInput]);

    
    React.useEffect(() => {
        setSearchInput('');
        setLastSearchedInput('');
        setIsSearching(false);
    }, [selectedCompany]);

    function onChange(event){
        event.preventDefault();
        setSearchInput(event.target.value);
    }

    function clickCompany(company){
        // console.log(company);
        setSelectedCompany(company);
    }

    const dropdownVisible = inputFocused && searchInput && companyList.length > 0;

    console.log("selectedCompany", selectedCompany);

    return (
        <Container>
            {selectedCompany.id ?
                <span>{selectedCompany.properties.name.toUpperCase()} {!props.readOnly && <span onClick={() => setSelectedCompany({})}><img src='/img/x_noir.png' alt=""/></span>}</span>
            :
                <Input style={{width:"100%"}} placeholder={inputFocused ? (i18n.language === 'fr' ? "Recherchez..." : "Search...") : (i18n.language === 'fr' ? "Société" : "Company")} onChange={onChange} onFocus={() => setInputFocused(true)} onBlur={() => setTimeout(() => setInputFocused(false),500)} />
            }
            <input hidden readOnly name={props.name} value={selectedCompany.id || ''}/>
            <div className={dropdownVisible ? 'select_panel' : 'hidden'} >
                {companyList.map((company) => {
                    return (
                        <div className='select_option' key={company.id} onClick={() => clickCompany(company)}>
                            {company.properties.name.toUpperCase()}
                        </div>
                    )
                })}
                <div className='info'>
                    <h2 className='centered'>
                        {i18n.language === 'fr' ? "Si vous ne trouvez pas votre société, vous pourrez la créer à l'étape suivante" : "If you can't find your company you will be able to create it in the next step"}
                    </h2>
                </div>
            </div>
        </Container>
    );
}

export default CompanySelect;
